import { useMemo } from "react";
import { useQueryCore } from "@/hooks/useQueryCore";
import { useDistrictGuard } from "@/hooks/useDistrictGuard";
import { getVisits } from "@/lib/api";

export function usePersonVisits(personId, { limit = 5 } = {}) {
  const { districtId } = useDistrictGuard();

  // Reuse the same cache key as Visits/useVisitsAgenda — no extra network request.
  const { data, loading } = useQueryCore({
    key:      ["visits-agenda", districtId],
    enabled:  !!districtId && !!personId,
    cacheKey: districtId ? `visits_district_${districtId}` : null,
    queryFn:  () => getVisits({ district_id: districtId }),
  });

  const allVisits = useMemo(() => (Array.isArray(data) ? data : []), [data]);

  const { visits, total } = useMemo(() => {
    if (!personId) return { visits: [], total: 0 };
    const filtered = allVisits
      .filter((v) => v.target_person_id === personId)
      .sort((a, b) => {
        if (!a.date && !b.date) return 0;
        if (!a.date) return 1;
        if (!b.date) return -1;
        return b.date.localeCompare(a.date);
      });
    return { visits: filtered.slice(0, limit), total: filtered.length };
  }, [allVisits, personId, limit]);

  return { visits, total, loading };
}
